import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { CalendarClockIcon, FileBoxIcon } from "lucide-react";
import { useNegotiationProductHistories } from "../../hooks/useNegotiationProductsHistories";
import { ProductData } from "@/common/types/product.type";
import Badge from "@/common/components/Badge";
import { useState } from "react";
import NegotiationProductHistoriesLoadingState from "./ProductHistories/ProductHistoriesLoadingState";
import NegotiatingProductHistoryItem from "./ProductHistories/ProductHistoryItem";
import { twMerge } from "tailwind-merge";
import { CompanyData as ClientCompanyData } from "@/common/types/companies/companies.type";
import { useMineCompany } from "@/features/company/hooks/useMineCompany";

interface NegotiationProductHistoriesModalProps {
  product: ProductData;
  clientCompany?: ClientCompanyData;
  negotiationProductId: string;
}

const NegotiationProductHistoriesModal = ({ product, clientCompany, negotiationProductId }: NegotiationProductHistoriesModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data: establishment } = useMineCompany();

  let {
    data: negotiationProductHistories,
    isPending: negotiationProductHistoriesIsPending,
  } = useNegotiationProductHistories({
    enabled: isOpen,
    negotiationProductId,
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button variant="neutral" className="bg-white-800/40 text-black-600 italic w-full text-sm">
            Conferir histórico da negociação

            <CalendarClockIcon strokeWidth={1.5} size={18} />
          </Button>
        )}
        title="Histórico de preços"
        body={(
          <div className={twMerge(
            'flex flex-col gap-6 text-white-800 max-h-[520px] overflow-y-auto',
            negotiationProductHistoriesIsPending && 'overflow-hidden'
          )}>
            <Badge
              Icon={FileBoxIcon}
              iconProps={{ size: 20, strokeWidth: 1.5 }}
              text={product.display_name}
              className="rounded-sm flex bg-neutral-op-8 w-fit flex-row-reverse !p-0 gap-0"
              overwriteClassName
              contentClassName="px-3 py-2"
            />

            <>
              {negotiationProductHistoriesIsPending && <NegotiationProductHistoriesLoadingState />}

              {!negotiationProductHistoriesIsPending && negotiationProductHistories?.map((negotiationproductHistory) => (
                <NegotiatingProductHistoryItem
                  key={negotiationproductHistory.id}
                  negotiationproductHistory={negotiationproductHistory}
                  clientCompany={clientCompany}
                  establishment={establishment}
                />
              ))}
            </>
          </div>
        )}

      />
    </>
  );
};

export default NegotiationProductHistoriesModal;
